'use strict';
(function () {
  if (window.VSKLOCartPopupUI) return;

  function create(options) {
    options = options || {};
    var formatMoney = options.formatMoney || function (cents) { return String(cents || 0); };
    var isNoEngravingAddon = options.isNoEngravingAddon || function () { return false; };
    var getRequiredTextMessage = options.getRequiredTextMessage || function () { return ''; };
    var collectAddonText = options.collectAddonText || function () { return ''; };

    var CART_MOBILE_QUERY = '(max-width: 749px)';

    function isCartAddonMobile() {
      return window.matchMedia && window.matchMedia(CART_MOBILE_QUERY).matches;
    }

    function getCartAddonPopup(node) {
      return (node && node.closest && node.closest('.vsklo-cart-addon-popup')) || null;
    }

    function getCartPopupLabel(popup, name, fallback) {
      var value = popup && popup.dataset ? popup.dataset[name] : '';
      if (value && String(value).indexOf('Translation missing') === -1) return value;
      var keys = {vskloTextAddLabel:'addText',vskloTextCancelLabel:'cancelText',vskloTextAddedLabel:'textAdded',vskloTextEditLabel:'editText'};
      var key = keys[name];
      var translated = key && window.vskloStrings?.addons?.[key];
      return translated && String(translated).indexOf('Translation missing') === -1 ? translated : fallback;
    }

    function getCartAddonCheckbox(addon) {
      return addon?.querySelector?.('.product-addons-popup__addon-checkbox') || null;
    }

    function isCartAddonSelectableForSubmit(checkbox) {
      if (!checkbox) return false;
      var addon = checkbox.closest('.product-addons-popup__addon');
      return Boolean(
        !checkbox.disabled &&
        checkbox.dataset.vskloAddonAvailable !== 'false' &&
        addon?.dataset?.vskloAddonAvailable !== 'false'
      );
    }

    function getCartAddonTextWrap(addon) {
      return addon?.querySelector?.(
        '.product-addons-popup__addon-input__wrap, .product-addons-popup__addon-input-wrap, .vsklo-cart-addon-text-wrap, .vsklo-engraving-field-wrap, .vsklo-mobile-sms-field-wrap, .vsklo-sms-field-ready'
      ) || null;
    }

    function getCartAddonTextFields(addon) {
      if (!addon) return [];
      return Array.from(addon.querySelectorAll([
        'textarea.vsklo-cart-popup-addon-text',
        'textarea.product-addons-popup__addon-input',
        'textarea.addon-text',
        'input.vsklo-cart-popup-addon-text',
        'input.product-addons-popup__addon-input',
        'input.addon-text'
      ].join(','))).filter(function (field) {
        return !field.closest('.product-addons-popup__addon-file-wrap');
      });
    }

    function getCartAddonVisibleTextField(addon) {
      var fields = getCartAddonTextFields(addon);
      return fields.find(function (field) {
        var rect = field.getBoundingClientRect();
        var style = window.getComputedStyle(field);
        return rect.width > 1 && rect.height > 1 && style.display !== 'none' && style.visibility !== 'hidden';
      }) || fields[0] || null;
    }

    function isCartPopupTextAddon(addon) {
      return Boolean(addon && !isNoEngravingAddon(addon));
    }

    function syncCartPopupTextFields(addon, value) {
      getCartAddonTextFields(addon).forEach(function (field) {
        if (field.value !== value) field.value = value;
        try { field.dispatchEvent(new Event('input', { bubbles: true })); } catch (error) {}
        try { field.dispatchEvent(new Event('change', { bubbles: true })); } catch (error) {}
      });
    }

    function setCartPopupAddonChecked(addon, checked) {
      var checkbox = getCartAddonCheckbox(addon);
      if (!checkbox) return;
      checkbox.checked = Boolean(checked);
      addon.classList.toggle('is-active', Boolean(checked));
      try { checkbox.dispatchEvent(new Event('change', { bubbles: true })); } catch (error) {}
    }

    function hideCartPopupKeyboard(field) {
      try { if (field && typeof field.blur === 'function') field.blur(); } catch (error) {}
      try {
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
      } catch (error) {}

      window.setTimeout(function () {
        var sink = document.getElementById('vsklo-cart-mobile-focus-sink');
        if (!sink) {
          sink = document.createElement('button');
          sink.type = 'button';
          sink.id = 'vsklo-cart-mobile-focus-sink';
          sink.setAttribute('aria-hidden', 'true');
          sink.tabIndex = -1;
          document.body.appendChild(sink);
        }
        try { sink.focus({ preventScroll: true }); } catch (error) {}
        window.setTimeout(function () {
          try { sink.blur(); } catch (error) {}
        }, 60);
      }, 20);
    }

    function clearCartPopupTextInlineStyles(addon) {
      if (!addon) return;
      var props = [
        'display','visibility','opacity','height','min-height','max-height','margin',
        'margin-top','margin-bottom','padding','padding-top','padding-bottom','overflow',
        'overflow-y','pointer-events'
      ];

      [
        getCartAddonTextWrap(addon),
        addon.querySelector('.vsklo-mobile-text-actions'),
        addon.querySelector('.vsklo-mobile-text-done')
      ].forEach(function (node) {
        if (!node || !node.style) return;
        props.forEach(function (prop) { node.style.removeProperty(prop); });
      });

      getCartAddonTextFields(addon).forEach(function (field) {
        props.forEach(function (prop) { field.style.removeProperty(prop); });
        field.removeAttribute('aria-hidden');
        field.disabled = false;
      });
    }

    function ensureCartMobileTextControls(addon) {
      if (!isCartAddonMobile() || !addon || !isCartPopupTextAddon(addon)) return;
      var checkbox = getCartAddonCheckbox(addon);
      if (!checkbox || !checkbox.checked) return;

      var wrap = getCartAddonTextWrap(addon);
      if (!wrap) return;

      var popup = getCartAddonPopup(addon);
      var confirmLabel = getCartPopupLabel(popup, 'vskloTextAddLabel', '✓ Додати текст');
      var cancelLabel = getCartPopupLabel(popup, 'vskloTextCancelLabel', 'Відмінити');
      var doneLabel = getCartPopupLabel(popup, 'vskloTextAddedLabel', '✓ Текст додано');
      var editLabel = getCartPopupLabel(popup, 'vskloTextEditLabel', 'Редагувати');

      var actions = addon.querySelector(':scope > .vsklo-mobile-text-actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.className = 'vsklo-mobile-text-actions';
        actions.innerHTML =
          '<button type="button" class="vsklo-mobile-text-confirm" data-vsklo-mobile-confirm-text>' +
          confirmLabel +
          '</button><button type="button" class="vsklo-mobile-text-cancel" data-vsklo-mobile-cancel-text>' +
          cancelLabel +
          '</button>';
        wrap.insertAdjacentElement('afterend', actions);
      }

      var done = addon.querySelector(':scope > .vsklo-mobile-text-done');
      if (!done) {
        done = document.createElement('div');
        done.className = 'vsklo-mobile-text-done';
        done.innerHTML =
          '<span>' + doneLabel + '</span>' +
          '<button type="button" data-vsklo-mobile-edit-text>' + editLabel + '</button>';
        actions.insertAdjacentElement('afterend', done);
      }
    }

    function refreshCartMobileTextControls(popup) {
      if (!isCartAddonMobile() || !popup) return;
      popup.querySelectorAll('.product-addons-popup__addon').forEach(function (addon) {
        var checkbox = getCartAddonCheckbox(addon);
        if (!checkbox || !isCartPopupTextAddon(addon)) return;
        if (checkbox.checked) ensureCartMobileTextControls(addon);
        addon.classList.toggle(
          'vsklo-mobile-text-open',
          checkbox.checked &&
          !addon.classList.contains('vsklo-mobile-text-confirmed') &&
          !addon.classList.contains('vsklo-mobile-text-collapsed')
        );
      });
    }

    function clearAddonInlineError(addon) {
      if (!addon) return;
      addon.classList.remove('vsklo-addon-error', 'vsklo-addon-field-error');
      addon.querySelectorAll('.vsklo-addon-field-error__message').forEach(function (node) {
        node.remove();
      });
      addon.querySelectorAll('[aria-invalid="true"]').forEach(function (node) {
        node.removeAttribute('aria-invalid');
      });
    }

    function showAddonInlineError(addon, message) {
      if (!addon) return;
      clearAddonInlineError(addon);
      addon.classList.add('vsklo-addon-error', 'vsklo-addon-field-error');

      var field = getCartAddonVisibleTextField(addon);
      if (field) {
        field.classList.add('is-error');
        field.setAttribute('aria-invalid', 'true');
      }

      var error = document.createElement('div');
      error.className = 'vsklo-addon-field-error__message';
      error.textContent = message;

      var inputWrap = field?.closest?.('.vsklo-addon-input-wrap');
      if (inputWrap && inputWrap.parentNode) {
        inputWrap.insertAdjacentElement('afterend', error);
      } else {
        (field && field.parentNode ? field.parentNode : addon).appendChild(error);
      }
    }

    function confirmCartMobileText(button) {
      var addon = button?.closest?.('.product-addons-popup__addon');
      if (!addon) return;
      var field = getCartAddonVisibleTextField(addon);
      var value = String(field?.value || '').trim();

      if (!value) {
        showAddonInlineError(addon, getRequiredTextMessage(addon));
        if (field) {
          try { field.focus({ preventScroll: false }); } catch (error) {}
          try { field.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (error) {}
        }
        return;
      }

      syncCartPopupTextFields(addon, value);
      clearAddonInlineError(addon);
      addon.classList.add('vsklo-mobile-text-confirmed', 'vsklo-mobile-text-collapsed');
      addon.classList.remove('vsklo-mobile-text-open', 'vsklo-addon-error');
      addon.setAttribute('data-vsklo-mobile-text-confirmed', 'true');
      setCartPopupAddonChecked(addon, true);
      hideCartPopupKeyboard(field);

      window.setTimeout(function () {
        addon.classList.add('vsklo-mobile-text-confirmed', 'vsklo-mobile-text-collapsed');
        addon.classList.remove('vsklo-mobile-text-open');
        hideCartPopupKeyboard(field);
      }, 80);
    }

    function cancelCartMobileText(button) {
      var addon = button?.closest?.('.product-addons-popup__addon');
      if (!addon) return;
      clearCartPopupTextInlineStyles(addon);
      syncCartPopupTextFields(addon, '');
      clearAddonInlineError(addon);
      addon.classList.remove(
        'vsklo-mobile-text-confirmed',
        'vsklo-mobile-text-collapsed',
        'vsklo-mobile-text-open',
        'vsklo-addon-error'
      );
      addon.removeAttribute('data-vsklo-mobile-text-confirmed');
      setCartPopupAddonChecked(addon, false);
    }

    function editCartMobileText(button) {
      var addon = button?.closest?.('.product-addons-popup__addon');
      if (!addon) return;
      clearCartPopupTextInlineStyles(addon);
      addon.classList.remove('vsklo-mobile-text-confirmed', 'vsklo-mobile-text-collapsed');
      addon.removeAttribute('data-vsklo-mobile-text-confirmed');
      addon.classList.add('vsklo-mobile-text-open');
      setCartPopupAddonChecked(addon, true);
      ensureCartMobileTextControls(addon);
      window.setTimeout(function () {
        clearCartPopupTextInlineStyles(addon);
        try { getCartAddonVisibleTextField(addon)?.focus({ preventScroll: false }); } catch (error) {}
      }, 60);
    }

    function handleCartMobileTextAction(action) {
      if (!action) return;
      if (action.matches('[data-vsklo-mobile-confirm-text]')) confirmCartMobileText(action);
      if (action.matches('[data-vsklo-mobile-cancel-text]')) cancelCartMobileText(action);
      if (action.matches('[data-vsklo-mobile-edit-text]')) editCartMobileText(action);
    }

    function getCartPopupParentQty(popup) {
      var button = popup?.querySelector('.js-vsklo-cart-addons-submit');
      return Math.max(1, parseInt(button?.dataset.parentQuantity || '1', 10) || 1);
    }

    function updatePopupTotal(popup) {
      if (!popup) return;
      var parentQty = getCartPopupParentQty(popup);
      var headEl = popup.querySelector('.product-addons-popup__current-product-price');
      var footerEl = popup.querySelector('.product-addons-popup__totals-price');
      var baseUnit = Number(
        headEl?.dataset?.vskloBasePriceCents ||
        headEl?.dataset?.price ||
        0
      );
      var baseTotal = baseUnit * parentQty;
      var addonsTotal = 0;

      popup.querySelectorAll('.product-addons-popup__addon-checkbox:checked').forEach(function (checkbox) {
        if (!isCartAddonSelectableForSubmit(checkbox)) return;
        addonsTotal += Number(checkbox.dataset.addonPrice || 0) * parentQty;
      });

      if (headEl) {
        headEl.dataset.vskloMoneyCents = String(baseTotal);
        headEl.textContent = formatMoney(baseTotal);
      }
      if (footerEl) {
        var combinedTotal = baseTotal + addonsTotal;
        footerEl.dataset.vskloMoneyCents = String(combinedTotal);
        footerEl.textContent = formatMoney(combinedTotal);
      }
    }

    function resetPopup(popup) {
      if (!popup) return;

      popup.querySelectorAll('.product-addons-popup__addon-checkbox').forEach(function (checkbox) {
        var wasChecked = checkbox.checked;
        checkbox.checked = false;
        if (wasChecked) checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      });

      popup.querySelectorAll('.product-addons-popup__addon').forEach(function (addon) {
        addon.classList.remove(
          'is-active',
          'vsklo-mobile-text-open',
          'vsklo-mobile-text-confirmed',
          'vsklo-mobile-text-collapsed',
          'vsklo-addon-error',
          'vsklo-addon-field-error'
        );
        addon.removeAttribute('data-vsklo-mobile-text-confirmed');
        clearCartPopupTextInlineStyles(addon);
        clearAddonInlineError(addon);
      });

      popup.querySelectorAll(
        '.product-addons-popup__addon-input, .vsklo-cart-popup-addon-text, .addon-text'
      ).forEach(function (input) {
        input.value = '';
      });
      popup.querySelectorAll('.addon-file').forEach(function (input) { input.value = ''; });
      popup.querySelectorAll('.product-addons-popup__addon-file-wrap').forEach(function (wrap) {
        wrap.classList.remove('file-uploaded');
      });
      popup.querySelectorAll('.product-addons-popup__addon-file-name').forEach(function (name) {
        name.textContent = '';
        name.removeAttribute('title');
      });

      updatePopupTotal(popup);
    }

    function cartAddonFocusable(popup) {
      if (!popup) return [];
      return Array.from(popup.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (node) {
        return node.offsetParent !== null && node.getAttribute('aria-hidden') !== 'true';
      });
    }

    function focusCartAddonDialog(popup) {
      if (!popup) return;
      window.requestAnimationFrame(function () {
        var target =
          popup.querySelector('.product-addons-popup__closer') ||
          cartAddonFocusable(popup)[0] ||
          popup;
        try { target.focus({ preventScroll: true }); }
        catch (error) {
          try { target.focus(); } catch (ignore) {}
        }
      });
    }

    function closePopup(popup) {
      if (!popup) return;

      window.clearTimeout(popup.__vskloHideTimer);
      popup.classList.remove('is-active');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('inert', '');

      if (window.VSKLOOverlayState) window.VSKLOOverlayState.release('cart-addon');
      else document.documentElement.classList.remove('open-popup');

      var opener = popup.__vskloOpener;
      popup.__vskloOpener = null;
      var returnParent = popup.__vskloReturnParent;
      var returnNextSibling = popup.__vskloReturnNextSibling;

      if (returnParent && returnParent.isConnected) {
        if (returnNextSibling && returnNextSibling.parentNode === returnParent) {
          returnParent.insertBefore(popup, returnNextSibling);
        } else {
          returnParent.appendChild(popup);
        }
      }

      popup.__vskloReturnParent = null;
      popup.__vskloReturnNextSibling = null;
      popup.__vskloHideTimer = window.setTimeout(function () {
        if (!popup.classList.contains('is-active')) popup.hidden = true;
      }, 220);

      if (opener && opener.isConnected && opener.focus) {
        window.requestAnimationFrame(function () {
          try { opener.focus({ preventScroll: true }); }
          catch (error) {
            try { opener.focus(); } catch (ignore) {}
          }
        });
      }
    }

    function trapCartAddonDialog(popup, event) {
      if (!popup || !popup.classList.contains('is-active')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closePopup(popup);
        return;
      }
      if (event.key !== 'Tab') return;

      var items = cartAddonFocusable(popup);
      if (!items.length) {
        event.preventDefault();
        popup.focus();
        return;
      }

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function validateSelectedPopupServices(popup) {
      if (window.VSKLOAddonEngine &&
          typeof window.VSKLOAddonEngine.validateWoodenBoxDependency === 'function' &&
          !window.VSKLOAddonEngine.validateWoodenBoxDependency(popup)) return false;
      var firstInvalid = null;

      popup.querySelectorAll('.product-addons-popup__addon-checkbox:checked').forEach(function (checkbox) {
        if (!isCartAddonSelectableForSubmit(checkbox)) return;

        var addon = checkbox.closest('.product-addons-popup__addon');
        clearAddonInlineError(addon);
        if (!addon || isNoEngravingAddon(addon)) return;

        var field = addon.querySelector(
          '[data-vsklo-same-text-field], [data-vsklo-text-part], .vsklo-addon-text, .vsklo-cart-popup-addon-text, .product-addons-popup__addon-input, .addon-text, textarea'
        );
        var text = collectAddonText(addon);
        if (!field || text) return;

        showAddonInlineError(addon, getRequiredTextMessage(addon));
        if (!firstInvalid) firstInvalid = field;
      });

      if (!firstInvalid) return true;
      try { firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (error) {}
      window.setTimeout(function () {
        try { firstInvalid.focus(); } catch (error) {}
      }, 120);
      return false;
    }

    function bindKeyboardTrap() {
      if (document.documentElement.dataset.vskloCartPopupKeyboardBound === '1') return;
      document.documentElement.dataset.vskloCartPopupKeyboardBound = '1';

      document.addEventListener('keydown', function (event) {
        var popup = document.querySelector('[data-vsklo-cart-addon-popup].is-active');
        if (popup) trapCartAddonDialog(popup, event);
      }, true);
    }

    bindKeyboardTrap();

    return Object.freeze({
      isCartAddonMobile: isCartAddonMobile,
      getCartAddonCheckbox: getCartAddonCheckbox,
      isCartAddonSelectableForSubmit: isCartAddonSelectableForSubmit,
      isCartPopupTextAddon: isCartPopupTextAddon,
      syncCartPopupTextFields: syncCartPopupTextFields,
      clearCartPopupTextInlineStyles: clearCartPopupTextInlineStyles,
      ensureCartMobileTextControls: ensureCartMobileTextControls,
      refreshCartMobileTextControls: refreshCartMobileTextControls,
      handleCartMobileTextAction: handleCartMobileTextAction,
      resetPopup: resetPopup,
      focusCartAddonDialog: focusCartAddonDialog,
      closePopup: closePopup,
      updatePopupTotal: updatePopupTotal,
      clearAddonInlineError: clearAddonInlineError,
      showAddonInlineError: showAddonInlineError,
      validateSelectedPopupServices: validateSelectedPopupServices
    });
  }

  window.VSKLOCartPopupUI = Object.freeze({
    create: create
  });
})();